var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tm-navbar", {
        attrs: {
          hero: _vm.isHero,
          links: _vm.navLinks,
          onShelfOpen: _vm.onShelfOpen
        }
      }),
      _c("tm-shelf", {
        attrs: {
          links: _vm.shelfLinks,
          visible: _vm.isShelfVisible,
          onClose: _vm.onShelfClose
        }
      }),
      _c(
        "div",
        { staticClass: "d-flex flex-column" },
        [
          _c("button", {
            staticClass: "tm-floating-btn",
            attrs: { id: "tm-back-to-top-btn", "aria-label": "Back to Top" }
          }),
          _c("main", [_c("transition", [_c("router-view")], 1)], 1),
          _c("tm-footer")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }